<template>
    <div>
        <div id="loadingMessage">
            <p>🎥 無法存取您的相機 (請允許相機使用權限)</p>
        </div>
        <canvas id="canvas" hidden style="width: 100%"></canvas>
        <video ref="videoRef" style="display:none;" />
        <div id="output">
            <div class="text-normal" id="messageContainer">
                <b id="outputMessage"></b>
            </div>
        </div>
        <div>

        </div>
        <div class="fileBox" href="javascript:;">
            <div class="fileBox__btn">
                <img src="@/assets/icon/pic.svg" />
            </div>
            <input class="fileBox__input" type="file" ref="file" accept="image/jpeg,image/png" @click="e=>{e.target.value = ''}" @change="handleFiles"/>
        </div>

    </div>
</template>

<script>
import jsQR from "jsqr";
export default {
    name: "QRCodeScanner",
    data: function() {
        return {
            isScan: true,
            timeoutId: null,
            availableTypes: ['https', 'checkin', 'checkin_random']
        }
    },
    mounted: function () {
        console.log("mounted");
        this.scanCode();
    },
    beforeDestroy () {
        this.fullStop();
    },
    computed: {
        video() {
            return this.$refs.videoRef;
        }
    },
    methods: {
        handleFiles(){
            let file = this.$refs.file.files[0]
            if (!file) return;

            const reader = new FileReader();

            reader.onload = (e) => {
                const image = new Image();
                image.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;

                    const context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, canvas.width, canvas.height);

                    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);

                    const code = jsQR(imageData.data, imageData.width, imageData.height, {
                    inversionAttempts: "dontInvert",
                    });
                    console.log('code: ', code)
                    if (code) {
                        this.isScan = false;
                        this.calcCode(code)
                    } else {
                        console.warn("沒有偵測到 QRCode");
                        this.showScannerError("無法從圖片解析出 QR Code");

                    }
                }
                image.src = e.target.result;
            }
            reader.readAsDataURL(file);
        },
        refresh() {
            this.isScan = true;
            this.startAnimationLoop()
        },
        scanCode() {
            this.$emit('create-video', this.video);
            // Use facingMode: environment to attempt to get the front camera on phones
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                this.startStreamedVideo(this.video, this.tick);
            } else {
                console.log('navigator.mediaDevices.getUserMedia does not supported');
                this.$emit('video-ready', false);
            }
            // this.startStreamedVideo(video, this.tick);
        },
        scanAction(code) {
            if (this.checkScanDataAvailable(code)) return true;
            return false;
        },
        checkScanDataAvailable(code) {
            if (code && code.data && this.availableTypes.includes(code.data.split(':')[0])) {
                return true;
            }
            return false;
        },
        stopStreamedVideo() {
            this.fullStop()
        },
        drawLine(canvas, begin, end, color) {
            canvas.beginPath();
            canvas.moveTo(begin.x, begin.y);
            canvas.lineTo(end.x, end.y);
            canvas.lineWidth = 4;
            canvas.strokeStyle = color;
            canvas.stroke();
        },
        drawText(canvas, text, begin, color = "#D65792") {
            canvas.font = "20px Arial";
            canvas.textAlign = "center";
            canvas.fillStyle = color;
            canvas.fillText(text, begin.x, begin.y);
        },
        drawCorners(canvas, width, height, color) {
            let align = 3;
            let lineWidth = 6;
            let lineLength = 35;

            let widthPositionWeight = 1 / 4;
            let heightPositionWeight = 1 / 3;

            let p1 = {
                x: width * widthPositionWeight,
                y: height * heightPositionWeight
            };
            let p2 = {
                x: width * (1 - widthPositionWeight),
                y: height * heightPositionWeight
            };
            let p3 = {
                x: width * widthPositionWeight,
                y: height * (1 - heightPositionWeight)
            };
            let p4 = {
                x: width * (1 - widthPositionWeight),
                y: height * (1 - heightPositionWeight)
            };

            // top left
            canvas.beginPath();
            canvas.lineWidth = lineWidth;
            canvas.strokeStyle = color;
            canvas.moveTo(p1.x - align, p1.y);
            canvas.lineTo(p1.x + lineLength, p1.y);
            canvas.stroke();

            canvas.beginPath();
            canvas.lineWidth = lineWidth;
            canvas.strokeStyle = color;
            canvas.moveTo(p1.x, p1.y);
            canvas.lineTo(p1.x, p1.y + lineLength);
            canvas.stroke();

            // top right
            canvas.beginPath();
            canvas.lineWidth = lineWidth;
            canvas.strokeStyle = color;
            canvas.moveTo(p2.x + align, p2.y);
            canvas.lineTo(p2.x - lineLength, p2.y);
            canvas.stroke();

            canvas.beginPath();
            canvas.lineWidth = lineWidth;
            canvas.strokeStyle = color;
            canvas.moveTo(p2.x, p2.y);
            canvas.lineTo(p2.x, p2.y + lineLength);
            canvas.stroke();

            // botton left
            canvas.beginPath();
            canvas.lineWidth = lineWidth;
            canvas.strokeStyle = color;
            canvas.moveTo(p3.x, p3.y + align);
            canvas.lineTo(p3.x, p3.y - lineLength);
            canvas.stroke();

            canvas.beginPath();
            canvas.lineWidth = lineWidth;
            canvas.strokeStyle = color;
            canvas.moveTo(p3.x + lineLength, p3.y);
            canvas.lineTo(p3.x, p3.y);
            canvas.stroke();

            // botton right
            canvas.beginPath();
            canvas.lineWidth = lineWidth;
            canvas.strokeStyle = color;
            canvas.moveTo(p4.x, p4.y + align);
            canvas.lineTo(p4.x, p4.y - lineLength);
            canvas.stroke();

            canvas.beginPath();
            canvas.lineWidth = lineWidth;
            canvas.strokeStyle = color;
            canvas.moveTo(p4.x, p4.y);
            canvas.lineTo(p4.x - lineLength, p4.y);
            canvas.stroke();
        },
        drawCode(canvas, code) {
            this.drawLine(
                canvas,
                code.location.topLeftCorner,
                code.location.topRightCorner,
                "#FF3B58"
            );
            this.drawLine(
                canvas,
                code.location.topRightCorner,
                code.location.bottomRightCorner,
                "#FF3B58"
            );
            this.drawLine(
                canvas,
                code.location.bottomRightCorner,
                code.location.bottomLeftCorner,
                "#FF3B58"
            );
            this.drawLine(
                canvas,
                code.location.bottomLeftCorner,
                code.location.topLeftCorner,
                "#FF3B58"
            );
        },
        tick() {
            var canvasElement = document.getElementById("canvas");
            if(canvasElement) {
                var canvas = canvasElement.getContext("2d");
                var loadingMessage = document.getElementById("loadingMessage");
                var outputContainer = document.getElementById("output");
                var outputMessage = document.getElementById("outputMessage");

                if (this.video?.readyState === this.video?.HAVE_ENOUGH_DATA) {
                    loadingMessage.hidden = true;
                    canvasElement.hidden = false;
                    outputContainer.hidden = false;

                    // canvasElement.height = video.videoHeight;
                    // canvasElement.width = video.videoWidth;
                    canvasElement.height = this.video?.videoHeight * 1;
                    canvasElement.width = this.video?.videoWidth * 1;

                    canvas.drawImage(
                        this.video,
                        0,
                        0,
                        canvasElement.width,
                        canvasElement.height
                    );

                    // this.drawText(
                    //     canvas,
                    //     "請掃描QR Code", {
                    //     x: canvasElement.width / 2,
                    //     y: canvasElement.height - 20
                    // });
                    this.drawCorners(
                        canvas,
                        canvasElement.width,
                        canvasElement.height,
                        "#FFFFFF"
                    );

                    var imageData = canvas.getImageData(
                        0,
                        0,
                        canvasElement.width,
                        canvasElement.height
                    );
                    var code = jsQR(
                        imageData.data,
                        imageData.width,
                        imageData.height,
                        {
                            inversionAttempts: "dontInvert"
                        }
                    );
                    if (code) {
                        console.log("code: ", code)
                        this.drawCode(canvas, code);
                        if (this.scanAction(code)) {
                            this.isScan = false;
                            this.calcCode(code)
                        } else {
                            outputMessage.innerText =
                                "資料異常";
                            this.isScan = true;
                            this.drawText(
                                canvas,
                                "商店代碼異常",
                                {
                                    x: canvasElement.width / 2,
                                    y: canvasElement.height / 2
                                },
                                "red"
                            );
                            this.drawCorners(
                                canvas,
                                canvasElement.width,
                                canvasElement.height,
                                "red"
                            );
                        }
                    } else {
                        this.isScan = true;
                        outputMessage.innerText = "";
                    }
                } else {
                    loadingMessage.innerText = "⌛ Loading video...";
                }
                this.startAnimationLoop()
            }
        },
        calcCode(code){
            console.log('qrcode code', code.data)
            // code.data = 'https://www.google.com/search?id=09&D01=1&D02=2&D03=3'

            let type = code.data.split(':')[0];
            let data = code.data.split(':')[1];

            // 不論掃到的資料是什麼，都會將 code 傳給父元件
            // this.$emit('code', code);

            switch (type) {
                case 'https':
                    this.$emit('get-url', code.data);
                    // window.location.href = code.data;
                    break;
                case 'checkin':
                    // 🔴 一定要往外送「掃到的原始字串」，不要只送 uuid。
                    //    標品的動態 QR 是四段：checkin:<uuid>:<timestamp>:<checksum>
                    //    （CheckInMissionActionService::getQRCodeData()），後端在
                    //    checksum_validate=1 時會用 hash(type+uuid+timestamp) 比對
                    //    checksum、並用 timestamp 判斷是否過期。
                    //    這裡若只送 data（split(':')[1] 只取得到 uuid），呼叫端重組成
                    //    checkin:<uuid> 兩段，後端一律回 "checksum not match" ——
                    //    等於動態 QR 全部報到不了，而靜態 QR（兩段）照常成功，
                    //    所以測試很容易漏掉（2026-09-23 dev 上有 7 張動態 QR）。
                    this.$emit('get-checkin', code.data);
                    break;
                case 'checkin_random': {
                    // 舊雲林格式：checkin_random:<uuid>?<timestamp(ms)>
                    // 15 秒的新鮮度檢查是這個格式自己的保護，保留。
                    // data is a45cbb20-a6ae-43b7-8d54-f8c96443f09c?1733493775585
                    const splitText = data.split('?');
                    // check the timestamp is in 15 seconds
                    if (splitText.length === 2) {
                        const timestamp = splitText[1];
                        const now = new Date().getTime();
                        if (now - timestamp > 15000) {
                            this.isScan = true;
                            this.showScannerError("QR Code 已過期");
                        } else {
                            // 同樣送原始字串，不要改寫成 checkin:<uuid> ——
                            // 改寫會把舊格式偽裝成標品的靜態碼，驗證結果不可信。
                            this.$emit('get-checkin-random', code.data);
                        }
                    }
                    break;
                }
                default:
                    break;
            }
        },
        showScannerError(errorMessage = "商店代碼異常") {
            var canvasElement = document.getElementById("canvas");
            var canvas = canvasElement.getContext("2d");
            outputMessage.innerText = "資料異常";
            this.drawText(
                canvas,
                errorMessage,
                {
                    x: canvasElement.width / 2,
                    y: canvasElement.height / 2
                },
                "red"
            );
            this.drawCorners(
                canvas,
                canvasElement.width,
                canvasElement.height,
                "red"
            );
        },
        startAnimationLoop() {
            if (this.isScan) {
                let hz = 30;
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(() => {
                    requestAnimationFrame(this.tick);
                }, 1/hz * 1000);
            }
        },
        startStreamedVideo(videoElem, tick) {
            const constraints = {
                advanced: [
                    {
                        aspectRatio: 1
                    }
                ]
            };
            // Use facingMode: environment to attempt to get the front camera on phones

            navigator.mediaDevices
                .getUserMedia({
                    video: {
                        facingMode: "environment"
                    }
                })
                .then((stream) => {
                    const track = stream.getVideoTracks()[0];
                    track.applyConstraints(constraints);
                    videoElem.srcObject = stream;
                    videoElem.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
                    videoElem.play();
                    this.$emit('video-ready', true);
                    requestAnimationFrame(tick);
                })
                .catch((getUserMediaErr) => {
                    console.log("getUserMediaErr: ", getUserMediaErr)
                    this.$emit('video-ready', false);
                })
        },
        fullStop () {
            if (this.video && this.video?.srcObject) {
                // 停止視訊流序列軌道
                this.video?.srcObject.getTracks().forEach(t => t.stop());
            }
        },
    }
};
</script>

<style scoped lang="scss">
 #loadingMessage {
    padding-left: 15px;
    top: 145px;
    position: fixed;
 }
 .fileBox{
    position: absolute;
    bottom: 160px;
    right:20px;
    height: 36px;
    width: 36px;
    &__input{
        position: absolute;
        inset: 0;
        opacity: 0;
        cursor: pointer;
        height: 36px;
    }
    &__btn{
        position: absolute;
        inset: 0;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
    }
}
</style>
